"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const httpRepository_1 = __importDefault(require("./httpRepository"));
const RequestProfilesRepository = {
    getProfiles: () => httpRepository_1.default.tradeshiftGo()
        .get('/rest/requestProfiles')
        .then(response => response.data),
    getProfile: (options) => httpRepository_1.default.tradeshiftGo().get('/rest/requestProfiles/' + options.profileId),
    getRequestProfilesForCompany: (options) => httpRepository_1.default.tradeshiftGo()
        .get('/rest/company/' + options.companyId + '/requestProfiles')
        .then(response => response.data),
    setProfileForCompany: (options) => httpRepository_1.default.tradeshiftGo().put('/rest/company/' + options.companyId + '/requestProfiles/' + options.profileId),
    removeProfileFromCompany: (options) => httpRepository_1.default.tradeshiftGo().delete('/rest/company/' + options.companyId + '/requestProfiles'),
};
exports.default = RequestProfilesRepository;
